(() => {
  const colorSwitcherSelector = '[js-cus-color-swatch]';

  // When the card is in "Use alternate product images" mode, prefer the
  // swatch's alt-image data (sourced from the target product's card_images
  // metafield) and fall back to its regular image data if no alt is present.
  const getSwatchImage = (item, swatch) => {
    const useAlt = item.dataset.useAltImages === 'true';
    const alt = swatch.dataset.productAltImage;
    return useAlt && alt ? alt : swatch.dataset.productImage;
  };

  const getSwatchHoverImage = (item, swatch) => {
    const useAlt = item.dataset.useAltImages === 'true';
    const alt = swatch.dataset.productAltHoverImage;
    return useAlt && alt ? alt : swatch.dataset.productHoverImage;
  };

  const updateSwatchImage = (item, targetSrc) => {
    const img = item.querySelector('[js-cus-image]');
    if (!img) return;

    const parent = img.parentElement; // .featured-media
    if (!parent) return;

    const currentRequestTime = Date.now();
    item.dataset.pendingRequest = currentRequestTime;
    item.dataset.pendingSrc = targetSrc;

    const currentBaseSrc = img.getAttribute('src');

    if (currentBaseSrc === targetSrc) {
      const existingOverlays = parent.querySelectorAll('.temp-transition-overlay');
      existingOverlays.forEach(overlay => {
        overlay.style.transition = 'opacity 0.3s ease';
        overlay.style.opacity = '0';
        // Remove after fade animation
        setTimeout(() => {
          if (overlay.parentNode) overlay.remove();
        }, 300);
      });
      img.style.opacity = '1';
      return;
    }

    
    const preloader = new Image();
    preloader.src = targetSrc;

    preloader.onload = () => {
      if (item.dataset.pendingRequest != currentRequestTime) return;
      delete item.dataset.pendingSrc;

      const overlay = document.createElement('img');
      overlay.src = targetSrc;
      overlay.className = 'temp-transition-overlay';
      
      Object.assign(overlay.style, {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: '2',
        opacity: '0', // Start hidden
        pointerEvents: 'none',
        transition: 'opacity 0.3s ease'
      });

      parent.appendChild(overlay);

      const oldOverlays = parent.querySelectorAll('.temp-transition-overlay');
      oldOverlays.forEach(el => {
        if (el !== overlay) el.remove();
      });

      void overlay.offsetWidth; 
      overlay.style.opacity = '1';

      setTimeout(() => {
        if (item.dataset.pendingRequest && item.dataset.pendingRequest != currentRequestTime) {}

        img.removeAttribute('data-srcset');
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.setAttribute('src', targetSrc);
        img.style.opacity = '1';

        const finish = () => {
          overlay.remove();
        };

        if (img.complete) {
          finish();
        } else {
          img.onload = finish;
          img.onerror = finish;
        }

      }, 300); // CSS transition
    };

    preloader.onerror = () => {
        console.warn('Failed to load swatch image:', targetSrc);
    };
  };

  document.addEventListener('click', function(e){
    const fnSwatch = e.target.closest(colorSwitcherSelector);
    if (!fnSwatch) return;
    
    const $swatch = fnSwatch;
    
    const productTitle = $swatch.dataset.productTitle;
    const productPrice = $swatch.dataset.productPrice;
    const productComparePrice = $swatch.dataset.productComparePrice;
    const productComparePriceNumber = Number(productComparePrice.replace('$', ''));
    const producUrl = $swatch.dataset.productUrl;
    const item = $swatch.closest("[js-cus-product]");
    const productImage = getSwatchImage(item, $swatch);
    const productHoverImage = getSwatchHoverImage(item, $swatch);

    if (item.querySelector('[js-product-title]')) item.querySelector('[js-product-title]').innerHTML = productTitle;
    if (item.querySelector('[js-product-price]')) item.querySelector('[js-product-price]').innerHTML = productPrice;
    if (item.querySelector('[js-product-compare-price]')) item.querySelector('[js-product-compare-price]').innerHTML = productComparePriceNumber > 0
      ? productComparePrice
      : '';

    // Apply logic (Preload -> Fade In Overlay -> Swap)
    updateSwatchImage(item, productImage);

    const jsCusHoverImage = item.querySelector('[js-cus-hover-image]');
    if (jsCusHoverImage) {
        jsCusHoverImage.removeAttribute('data-srcset');
        jsCusHoverImage.removeAttribute('srcset');
        jsCusHoverImage.removeAttribute('sizes');
        jsCusHoverImage.setAttribute('src', productHoverImage);
    }

    item.querySelectorAll('[js-product-url]').forEach(productAnchor => {
      productAnchor.setAttribute('href', producUrl);
    });
    
    const currentSwatchHandle = $swatch.getAttribute('data-product-handle');

    item.querySelectorAll(colorSwitcherSelector).forEach(colorSwitch => {
      const isCurrent = colorSwitch.getAttribute('data-product-handle') === currentSwatchHandle;
      colorSwitch.classList.toggle('active', isCurrent);
      if (colorSwitch.getAttribute('role') === 'radio') {
        colorSwitch.setAttribute('aria-checked', isCurrent ? 'true' : 'false');
        colorSwitch.setAttribute('tabindex', isCurrent ? '0' : '-1');
      }
    });

  });

  document.addEventListener('keydown', function(e){
    const back = e.key === 'ArrowLeft' || e.key === 'ArrowUp';
    const forward = e.key === 'ArrowRight' || e.key === 'ArrowDown';
    if (!back && !forward) return;

    const swatch = e.target.closest(colorSwitcherSelector);
    if (!swatch || swatch.getAttribute('role') !== 'radio') return;

    const group = swatch.closest('[role="radiogroup"]');
    if (!group) return;

    const radios = Array.from(group.querySelectorAll(colorSwitcherSelector));
    const index = radios.indexOf(swatch);
    if (index === -1 || radios.length < 2) return;

    const target = radios[(index + (forward ? 1 : -1) + radios.length) % radios.length];
    if (!target || target === swatch) return;

    e.preventDefault();
    target.focus();
    target.click();
  });
  
  document.addEventListener('mouseover', function(e) {
    if (window.innerWidth < 992) return;
    
    const swatch = e.target.closest(colorSwitcherSelector);
    if (!swatch) return;
    
    const item = swatch.closest("[js-cus-product]");
    if (!item) return;

    item.classList.add('swatch-hover-active');

    if (swatch.classList.contains('active')) return;

    const productImage = getSwatchImage(item, swatch);
    updateSwatchImage(item, productImage);
  });

  document.addEventListener('mouseout', function(e) {
    if (window.innerWidth < 992) return;
    
    const swatch = e.target.closest(colorSwitcherSelector);
    if (!swatch) return;
    
    if (swatch.contains(e.relatedTarget)) return;

    const item = swatch.closest("[js-cus-product]");
    if (!item) return;

    item.classList.remove('swatch-hover-active');
    
    const currentRequestTime = Date.now();
    item.dataset.pendingRequest = currentRequestTime; 

    const activeSwatch = item.querySelector(colorSwitcherSelector + '.active');
    if (activeSwatch) {
        const activeImage = getSwatchImage(item, activeSwatch);
        updateSwatchImage(item, activeImage);
    }
  });


  document.addEventListener('focusin', function(e) {
    if (window.innerWidth < 992) return;
    
    const swatch = e.target.closest(colorSwitcherSelector);
    if (!swatch) return;
    
    const item = swatch.closest("[js-cus-product]");
    if (!item) return;

    item.classList.add('swatch-hover-active');

    if (swatch.classList.contains('active')) return;

    const productImage = getSwatchImage(item, swatch);
    updateSwatchImage(item, productImage);
  });

  document.addEventListener('focusout', function(e) {
    if (window.innerWidth < 992) return;
    
    const swatch = e.target.closest(colorSwitcherSelector);
    if (!swatch) return;

    if (swatch.contains(e.relatedTarget)) return;

    const item = swatch.closest("[js-cus-product]");
    if (!item) return;

    item.classList.remove('swatch-hover-active');
    
    const currentRequestTime = Date.now();
    item.dataset.pendingRequest = currentRequestTime; 

    const activeSwatch = item.querySelector(colorSwitcherSelector + '.active');
    if (activeSwatch) {
        const activeImage = getSwatchImage(item, activeSwatch);
        updateSwatchImage(item, activeImage);
    }
  });
})()
